import { h, Component } from "preact";
const RichTextDisplay = ({ html }) => {
  return <div class="rich-text" dangerouslySetInnerHTML={{ __html: html }} />;
};
export default RichTextDisplay;
